// Centralized info copy for InfoPopup across Step 1 and Step 2
// Hydrated from ACF option fields via copyConfig

/**
 * Default fallback values for info popup content.
 */
const INFO_COPY_DEFAULTS = {
	aankoopbedrag: 'Toelichting op aankoopbedrag',
	looptijd: 'Toelichting op looptijd in maanden',
	aanbetaling: 'Toelichting op aanbetaling',
	slottermijn: 'Toelichting op slottermijn',
	maandbedrag: 'Toelichting op maandbedrag',
};

/**
 * Get info copy object from ACF option fields via copyConfig.
 *
 * Maps ACF field names to INFO_COPY keys and provides fallback values.
 *
 * @param {Object} copyConfig - Copy configuration object from PHP/ACF
 * @return {Object} Info copy object with keys matching INFO_COPY structure
 */
export function getInfoCopy( copyConfig = {} ) {
	if ( ! copyConfig || typeof copyConfig !== 'object' ) {
		return INFO_COPY_DEFAULTS;
	}

	return {
		aankoopbedrag: copyConfig.api_popup_aankoopbedrag || INFO_COPY_DEFAULTS.aankoopbedrag,
		looptijd: copyConfig.api_popup_looptijd || INFO_COPY_DEFAULTS.looptijd,
		aanbetaling: copyConfig.api_popup_aanbetaling || INFO_COPY_DEFAULTS.aanbetaling,
		slottermijn: copyConfig.api_popup_slottermijn || INFO_COPY_DEFAULTS.slottermijn,
		maandbedrag: copyConfig.api_popup_maandbedrag || INFO_COPY_DEFAULTS.maandbedrag,
	};
}

/**
 * Get inruilen callout copy from ACF option fields via copyConfig.
 *
 * Normalized to the same pattern as other text configs.
 *
 * @param {Object} copyConfig - Copy configuration object from PHP/ACF
 * @return {Object} Inruilen copy object with normalized keys
 */
export function getInruilenCopy( copyConfig = {} ) {
	if ( ! copyConfig || typeof copyConfig !== 'object' ) {
		return {
			buttonTitle: 'Ik wil een proefrit maken of mijn auto inruilen',
			blockTitle: '',
			blockContent: '',
		};
	}

	return {
		buttonTitle: copyConfig.api_inruilen_button_titel || 'Ik wil een proefrit maken of mijn auto inruilen',
		blockTitle: copyConfig.api_inruilen_blok_titel || '',
		blockContent: copyConfig.api_inruilen_blok_inhoud || '',
	};
}

